import type { CityConfig } from "../city-template/types";

export const carmelConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Carmel",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "carmel",
  route: "/cities/carmel",
  title: "Emergency Passport Carmel, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Carmel, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Carmel, Fishers, Westfield, Zionsville, and all Hamilton County residents. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Carmel, IN",
  heroSubtitle: "Carmel travelers — from the Carmel Arts & Design District to the roundabouts of Hamilton County to the affluent Indianapolis suburbs — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service with direct access to the Chicago Passport Agency.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Carmel%20Indiana%20downtown%20Arts%20and%20Design%20District%20with%20charming%20brick-paved%20streets%2C%20public%20art%20sculptures%2C%20outdoor%20cafes%2C%20and%20modern%20mixed-use%20architecture%2C%20the%20Palladium%20performing%20arts%20center%20visible%2C%20warm%20golden%20afternoon%20sunlight%2C%20professional%20city%20photography%2C%20affluent%20suburban%20atmosphere%20with%20elegant%20design%20details%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20warm%20tones%20and%20sophisticated%20suburban%20charm&width=1800&height=700&seq=carmel-hero-001&orientation=landscape",
  heroImageAlt: "Carmel Indiana Arts and Design District with Palladium and brick-paved streets",
  geoPosition: "39.9784;-86.1180",
  geoPlacename: "Carmel, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 180 miles, 3 hours via I-65",
  },
  nearbyCitiesZips: [
    { name: "Carmel", zips: "46032, 46033, 46074, 46082" },
    { name: "Fishers", zips: "46037, 46038, 46040, 46085" },
    { name: "Noblesville", zips: "46060, 46061, 46062" },
    { name: "Westfield", zips: "46033, 46074, 46075" },
    { name: "Zionsville", zips: "46077, 46068" },
    { name: "Avon", zips: "46123, 46234" },
    { name: "Plainfield", zips: "46168, 46122, 46234" },
    { name: "Brownsburg", zips: "46112" },
    { name: "Indianapolis", zips: "46201, 46202, 46203, 46204, 46205, 46206, 46208, 46214, 46217, 46218, 46219, 46220, 46221, 46222, 46224, 46225, 46226, 46227, 46228, 46229, 46231, 46234, 46235, 46236, 46237, 46239, 46240, 46241, 46250, 46254, 46256, 46259, 46260, 46268, 46278, 46280, 46290" },
    { name: "Greenwood", zips: "46142, 46143, 46184" },
    { name: "Lawrence", zips: "46226, 46236, 46256" },
    { name: "Greenfield", zips: "46140" },
    { name: "Franklin", zips: "46131" },
    { name: "Anderson", zips: "46011, 46012, 46013, 46014, 46015, 46016, 46017, 46018" },
    { name: "Muncie", zips: "47302, 47303, 47304, 47305, 47306, 47307" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Direct courier service to the Chicago Passport Agency — about 3 hours via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "Hamilton County Affluent Hub", desc: "Serving Carmel, Fishers, and Noblesville professionals and families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — or same-day hand delivery to Indy agency" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Urgent passport services in Evansville, IN", route: "/evansville" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "1 American Square, Indianapolis, IN 46282",
  mapEmbedUrl: "https://www.google.com/maps?q=1+American+Square,+Indianapolis,+IN+46282&output=embed",
  fpcOfficeNote: "Visit the Fast Passport Center office at 1 American Square in downtown Indianapolis by appointment only. Sign up on our website first to schedule your visit — walk-ins are not accepted. Serving Carmel, Fishers, Noblesville, and all Hamilton County travelers.",
  fpcOfficeDistance: "Serving Carmel, Fishers, Noblesville, Westfield, Zionsville, Avon, Plainfield, Brownsburg, Lawrence, and all of Hamilton County and the Indianapolis northern suburbs",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Carmel and Hamilton County. From the Carmel Arts & Design District to the Fishers Nickel Plate District, from Noblesville to Westfield and Zionsville — we serve all of Hamilton County and the Indianapolis northern suburbs.",
  nearbyCitiesIntro: "We serve Carmel and all nearby communities including Fishers, Noblesville, Westfield, Zionsville, Avon, Plainfield, Brownsburg, Indianapolis, Greenwood, Lawrence, Greenfield, Franklin, Anderson, and Muncie. We also serve all of Hamilton County, Marion County, and the greater Indianapolis metropolitan area.",
  howItWorksIntro: "Most Carmel travelers complete everything online and ship documents overnight. Because the Chicago Passport Agency is only 20 minutes away, we can often hand-deliver the same day — faster than any other suburb in Indiana.",
  mistakesIntro: "Carmel is one of the most affluent suburbs in the Midwest, with significant international travel from professionals, families, and business owners. Here are the most common passport mistakes we see from Hamilton County travelers.",
  testimonialsIntro: "Carmel travelers — from corporate professionals to families to international business owners — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Carmel, IN? Here are the most common ones we hear from Hamilton County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — courier handles the 3-hour drive", "No long drive required", "Perfect for business and family travel deadlines", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — courier handles the 3-hour drive", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3 hours to Chicago — full day commitment", "Rarely available for non-life-or-death cases"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Carmel travelers with immediate departure needs — as fast as 24 hours. Our couriers hand-deliver to the Chicago Passport Agency — about 3 hours via I-65.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 3-hour drive", "Hamilton County business and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Carmel adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Hamilton County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Carmel residents and families — including Hamilton County students, new citizens, and suburban families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Carmel residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Carmel and Hamilton County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Carmel and Hamilton County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Carmel IN", description: "Urgent passport processing for Carmel Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Carmel IN", description: "Fast passport renewal for Carmel Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Carmel IN", description: "New passport application services for Carmel Indiana residents applying for their first passport." },
    { name: "Child Passport Carmel IN", description: "Minor passport services for Carmel Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Patricia L.",
      location: "Carmel, IN",
      rating: 5,
      text: "Conference in Zurich in 4 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. The Chicago Passport Agency is literally 20 minutes away — this service is a game changer. Outstanding.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Fishers, IN",
      rating: 5,
      text: "Family trip to Europe with 10 days notice. Four passports — two renewals and two first-time for our kids. Done in 4 days. We shipped from UPS on 116th and everything was perfect.",
      service: "Family Passport Bundle",
    },
    {
      name: "Jennifer W.",
      location: "Noblesville, IN",
      rating: 5,
      text: "Business trip to Tokyo with 8 days notice. Fast Passport Center walked me through every step and had my passport in 3 days. Being so close to the Chicago Passport Agency is a huge advantage.",
      service: "Emergency Passport",
    },
    {
      name: "David M.",
      location: "Carmel, IN",
      rating: 5,
      text: "Lost my passport the week before a family cruise to the Caribbean. Fast Passport Center replaced it in 48 hours. The proximity to the Indianapolis agency made all the difference.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "carmel-1",
      name: "Carmel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2750 E 146th St",
      city: "Carmel",
      state: "IN",
      zip: "46033",
      phone: "(317) 846-3504",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Carmel, near the Arts & Design District",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Carmel acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient to Carmel Arts & Design District and downtown Carmel.",
      icon: "ri-mail-line",
    },
    {
      id: "carmel-2",
      name: "Fishers Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11601 Municipal Dr",
      city: "Fishers",
      state: "IN",
      zip: "46038",
      phone: "(317) 579-5251",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fishers, approximately 5 miles east of Carmel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Fishers and eastern Hamilton County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "carmel-3",
      name: "Noblesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 S 10th St",
      city: "Noblesville",
      state: "IN",
      zip: "46060",
      phone: "(317) 773-2803",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Noblesville, approximately 10 miles northeast of Carmel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Noblesville and northern Hamilton County residents. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "carmel-4",
      name: "Westfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "17536 Dartown Rd",
      city: "Westfield",
      state: "IN",
      zip: "46074",
      phone: "(317) 896-3335",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Westfield, approximately 8 miles west of Carmel",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Westfield and western Hamilton County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "carmel-5",
      name: "Hamilton County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1 Hamilton County Sq",
      city: "Noblesville",
      state: "IN",
      zip: "46060",
      phone: "(317) 776-9617",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Noblesville County Building",
      website: "https://www.hamiltoncounty.in.gov/",
      websiteLabel: "Hamilton County",
      notes: "County Clerk passport acceptance for Hamilton County. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, appointment required", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 180-mile, 3-hour drive to Chicago via I-65", fpc: "No — we deliver for you" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Local Advantage", agency: "Chicago is the nearest passport agency to Indiana", fpc: "We leverage Chicago agency access for Carmel clients" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Carmel professionals and families often discover passport issues just before international trips. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near the Arts & Design District or Clay Terrace sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Hamilton County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Carmel Post Office appointments fill during summer and holiday travel seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-calendar-line",
      title: "Assuming Spring Break Is Far Enough Away",
      description: "Many Hamilton County families plan Caribbean spring break trips. March is peak passport demand in Carmel — plan accordingly.",
    },
    {
      icon: "ri-time-line",
      title: "Assuming 4–6 Weeks Is Enough",
      description: "Routine processing takes 6–13 weeks. If your travel is within 10 weeks, use expedited service. Spring break and summer travel peaks March through August.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Carmel or Hamilton County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near the Arts & Design District or Clay Terrace." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier hand-delivers to the Chicago Passport Agency — about 3 hours from Carmel via I-65." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Carmel address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Carmel, IN?", a: "Fast Passport Center offers emergency passport processing in Carmel, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — no need to make the 3-hour drive yourself." },
    { q: "Does Carmel have its own passport agency?", a: "No — Carmel does not have its own passport agency. The nearest is the Chicago Passport Agency, approximately 180 miles away (about 3 hours via I-65). Fast Passport Center's courier service means Carmel and Hamilton County residents never need to make the trip to Chicago themselves." },
    { q: "Can I get an expedited passport in Fishers, Noblesville, or Westfield?", a: "Absolutely. Fast Passport Center serves all of Hamilton County including Fishers, Noblesville, Westfield, Zionsville, and Avon. Our couriers handle the Chicago Passport Agency delivery so you never need to make the 3-hour drive." },
    { q: "What airport do Carmel travelers use for international flights?", a: "Indianapolis International Airport (IND) is the primary airport for Carmel and Hamilton County. IND is only 25 minutes south via I-465 and offers direct flights to Toronto, Cancun, and Paris (seasonal) plus connecting service worldwide. Always verify passport validity for at least 6 months past your return date." },
    { q: "How much does an expedited passport cost in Carmel, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Carmel?", a: "Walgreens, CVS, and Walmart stores throughout Carmel, Fishers, and Noblesville offer passport photos. UPS Store and FedEx Office locations also provide them. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Carmel business professionals?", a: "Yes. Fast Passport Center serves all of Hamilton County including Carmel, Fishers, and Noblesville business professionals. We understand international business travel deadlines and conference schedules. Our Chicago Passport Agency proximity is especially valuable for last-minute corporate travel needs." },
    { q: "Is Carmel the fastest suburb in Indiana for passport service?", a: "Carmel and Hamilton County residents benefit from Fast Passport Center's registered courier service to the Chicago Passport Agency, the nearest regional passport agency to Indiana. While the drive is approximately 3 hours, our couriers handle it so you never need to make the trip yourself. Fort Wayne and Evansville residents face similar or longer drives to a passport agency." },
  ],
  photoLocations: [
    { name: "Walgreens — Carmel", address: "1414 S Rangeline Rd, Carmel, IN 46032", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart — Carmel", address: "2001 E 151st St, Carmel, IN 46033", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "UPS Store — Carmel", address: "1250 E 146th St, Carmel, IN 46032", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://locations.theupsstore.com/in/carmel" },
    { name: "FedEx Office — Carmel", address: "1420 S Rangeline Rd, Carmel, IN 46032", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://local.fedex.com/en-us/in/carmel" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Carmel", address: "14560 River Rd, Carmel, IN 46033", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended.", featured: true },
    { name: "Indiana BMV — Fishers", address: "9790 E 126th St, Fishers, IN 46038", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves Fishers and eastern Hamilton County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "25 minutes south of Carmel via I-465",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Carmel and Hamilton County. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. Only 25 minutes from Carmel.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3.5 hours northwest of Carmel via I-65",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major hub for Carmel travelers seeking more international routes. United and American Airlines hub with global connections.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International Airport",
      distance: "Approximately 2.5 hours southeast of Carmel via I-74",
      address: "2939 Terminal Dr, Hebron, KY 41048",
      note: "Alternative airport for Carmel travelers. Delta hub with domestic and international connections.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Hamilton County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Hamilton County and all Indiana counties" },
    { label: "Hamilton County Clerk: Marriage Licenses", url: "https://www.hamiltoncounty.in.gov/", icon: "ri-heart-line", description: "Hamilton County Clerk — marriage license records for Carmel and Hamilton County" },
    { label: "Hamilton County: Divorce Decrees", url: "https://www.hamiltoncounty.in.gov/", icon: "ri-file-list-3-line", description: "Hamilton County Clerk of Courts — divorce decree records for Carmel and Hamilton County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Carmel address" },
  ],
};